import { Container, Grid, Typography } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';
import { PrintButton } from '../PrintButton';
import { ScreenTitle } from '../ScreenTitle';

type Props = PropsWithChildren<{
	title?: string;
}>;

export const PrintableLayout: FunctionComponent<Props> = (props) => {
	return <Container maxWidth="md" sx={{
		padding: 4,
		'@media print': {
			backgroundColor: 'white',
			color: 'black',
			padding: 4,
		},
	}}>
		<ScreenTitle title={props.title} />
		<Grid container>
			<Grid size={8} offset={2}>
				{props.title && <Typography variant="h4" component="h1" sx={{
					marginBottom: 4,
					textAlign: 'center',
					fontWeight: 'bold',
					'@media print': {
						fontSize: '1.5rem',
						marginBottom: 2,
					},
				}}>
					{props.title}
				</Typography>}
			</Grid>
			<Grid size={1} offset={props.title ? 1 : 9}>
				<PrintButton />
			</Grid>
		</Grid>
		{props.children}
	</Container>;
};